import { SpendTracker } from '@webapp/components/Budgets'
import { ErrorBoundary } from '@webapp/components/ErrorBoundary'
import { SpendTrackerPresenterStyled } from './styles/SpendTrackerPresenterStyled'
import { useSpendTrackerPresenter } from './useSpendTrackerPresenter'

interface ISpendTrackerPresenterProps {
  expenseUuid: string
}

export const SpendTrackerPresenter = ({
  expenseUuid,
}: ISpendTrackerPresenterProps) => {
  const {
    data: {
      budgetCategories,
      processedBudgetData,
      primaryCategory,
      secondaryCategory,
      secondaryCategorySpend,
      headquartersTimezone,
      uncategorizedSpend,
    },
    states: { isSpendTrackerEnabled, isSpendTrackerDataLoading },
  } = useSpendTrackerPresenter({ expenseUuid })

  if (!isSpendTrackerEnabled) return null

  return (
    <SpendTrackerPresenterStyled>
      <ErrorBoundary boundaryName='SpendTrackerPresenter'>
        <SpendTracker
          primaryOrganizationName={primaryCategory?.name}
          secondaryOrganizationName={secondaryCategory?.name}
          isLoading={isSpendTrackerDataLoading}
          budgetCategories={budgetCategories}
          departmentalSpend={secondaryCategorySpend}
          processedBudgetData={processedBudgetData}
          uncategorizedSpend={uncategorizedSpend}
          timeZoneTooltip={headquartersTimezone}
        />
      </ErrorBoundary>
    </SpendTrackerPresenterStyled>
  )
}
